import { useEffect, useState } from "react";
import Barchart from "./Barchart";


function BarchartSelection({year, demographics, movement}) {

    const [Data, setData] = useState([])

    var url = ""
    if(movement.length === 0){
      url = '/api/infoforcharacteristic/'+ year + '/' + demographics;
    }
    else {
      url = '/api/infoformovement/'+ year + '/' + movement;
    }
    useEffect(() => {
        
        fetch(url).then((res) =>
            res.json().then((res) => {
                
                console.log(res)
                let listOfValues = []
                let listOfLabels =[]
                  // if(movement !== "Προσδιορισμός κατά σειρά προτίμησης μέσω διαβαθμισμένης κλίμακας 1-5") {
                    res.data.Info.map((obj)=>{
                        listOfValues.push(obj["Ποσοστό"]*100)
                        listOfLabels.push(obj["Απάντηση"])
                        return(0)
                        
                    })

                    setData({
                      labels: listOfLabels,
                      datasets: [{
                          label: "",
                          data: listOfValues,
                          backgroundColor: "blue",
                          borderColor: "black",
                          borderWidth: 0.1,
                      }]
                    })
                  // }else{
                  //   const keys = Object.keys(res.data.Info);
                  //   console.log("keys", keys)
                    

                  //   let keys2 = []
                  //   for(let i = 0; i < res.data.Info[keys[0]].length; i++){
                  //     console.log(res.data.Info[keys[0]][i]["Απάντηση"])
                  //     keys2.push(res.data.Info[keys[0]][i]["Απάντηση"])
                  //   }

                  //   console.log("keys2", keys2)
                    
                  //   const myObject = {};
                  //   keys.forEach((key) => {
                  //     myObject[key] = [];
                  //   });

                  //   keys.forEach((key, i) => {
                  //     myObject[key].push()
                  //   })
                  // }

          })
        )
        .catch((error) => {
          console.log("Refetching data!")
        });
      }, [url]);
    


    const options = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend : {
           display: false,
          }
        }
    }
    
    
    if(Data.length !== 0){
        return (
            <Barchart chartData = {Data} chartOptions = {options}/>
        );
    }
    else {
        return <></>
    }

    };

export default BarchartSelection;

